<template>
  <div id="payDraw"></div>
</template>
<script>
var chart;
export default {
  data() {
    return {
      myData: {
        xData: [
          "KM01",
          "KM02",
          "KM04",
          "KM05",
          "KM06",
          "KM07",
          "KM08",
          "KM09",
          "KM11",
          "KM12",
          "KM13",
          "KM14",
        ],
        yData: [12, 32, 15, 14, 27, 9, 7],
      },
    };
  },
  methods: {
    reachData(data) {
      console.log(data);
      this.myData = {
        xData: [],
        yData: [],
        yData2: [],
      };
      for (let i = 0; i < data.length; i++) {
        this.myData.xData.push(data[i].carNo);
        this.myData.yData.push(data[i].refuelVal);
        this.myData.yData2.push(data[i].mileageCsp);
      }
      this.draw();
    },
    draw() {
      var color=["#1d91c0","#e23838"];
      this.chart = this.echarts.init(document.getElementById("payDraw"));
      this.option = {
        backgroundColor: "",
        grid: {
          x: 40,
          y: 40,
          x2: 40,
          y2: 80, //距离下边的距离
        },
        /* dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ], */
        xAxis: {
          type: "category",
          data: this.myData.xData,
          axisLabel: { rotate: 45 },
        },
        yAxis: [
          {
            type: "value",
            name: "加油量/L",
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color:color[0],
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
          {
            type: "value",
            name: "百公里油耗/L",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: color[1],
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],
        color: color,
        series: [
          {
            data: this.myData.yData,
            type: "bar",
            name: "加油量",
            yAxisIndex: 0,
            label: {
              show: true,
              position: "top",
            },
          },
          {
            data: this.myData.yData2,
            type: "bar",
            name: "百公里油耗",
            yAxisIndex: 1,
            label: {
              show: true,
              position: "top",
            },
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name+val.seriesName + "：" + val.value + "L";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },
  },
  //调用
  mounted() {
    //this.drawBar("olinow");
    //this.draw();
  },
  destroyed() {},
};
</script>
<style lang="">
#payDraw {
  width: calc(100% - 20px);
  height: 300px;
  overflow: auto;
  background: #d4dfe9;
  margin: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/jiayou/draw.vue